// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__i8ZVD","SideDrawerContent":"SideDrawer_SideDrawerContent__OqLae","SideDrawerLogo":"SideDrawer_SideDrawerLogo__wH53q"};